<template>
    <div>
        <div class="row m-2">
            <div class="col-4">
                <DocumentTypeGraph></DocumentTypeGraph>
            </div>
            <div class="col-8">
            <DashboardUnfiltered />
                <div class="row">
                    <div class="col-4">
                        <DocumentCountGraph class="my-2"></DocumentCountGraph>
                    </div>
                    <div class="col-4">
                        <StatementCountGraph class="my-2"></StatementCountGraph>
                    </div>

                    <div class="col-4">
                        <MeetingCountGraph class="my-2"></MeetingCountGraph>
                    </div>
                    <div class="col-4">
                        <DenunciationCountGraph class="my-2"></DenunciationCountGraph>
                    </div>
                    <div class="col-4">
                        <KarinDenunciationCountGraph class="my-2"></KarinDenunciationCountGraph>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <NotificationCountGraph class="mt-2"></NotificationCountGraph>
            </div>
        </div>
    </div>
</template>
<script>
import DocumentTypeGraph from "./dashboardCompliance/Document-type-graph.vue";
import DocumentCountGraph from "./dashboardCompliance/Document-count-graph.vue";
import MeetingCountGraph from "./dashboardCompliance/Meeting-count-graph.vue";
import DenunciationCountGraph from "./dashboardCompliance/Denunciation-count-graph.vue";
import NotificationCountGraph from "./dashboardCompliance/Notification-count-graph.vue"
import StatementCountGraph from "@/components/home/dashboardCompliance/Statement-count-graph.vue";
import KarinDenunciationCountGraph from "./dashboardCompliance/Karin-Denunciation-count-graph.vue";
import DashboardUnfiltered from "./Dashboard-unfiltered.vue"

//signal r

import {
    allDocumentsSignalRInvoke,
    countDenunciationsSignalRInvoke,
    countDocumentsSignalRInvoke,
    countSendDenunciationSignalRInvoke,
    countSendDocumentsSignalRInvoke,
    countMeetsSignalRInvoke, 
    countStatementsSignalRInvoke,
    countSendStatementsSignalRInvoke,
    countKarinDenunciationsSignalRInvoke,
} from '@/plugins/storeSignalRInvoque/index.js';

//data
import {dateFormat} from '@/plugins/date/index.js'

export default {
    name: 'DashboardCompliance',

    components: {
        StatementCountGraph,
        DocumentTypeGraph,
        DocumentCountGraph,
        MeetingCountGraph,
        DenunciationCountGraph,
        NotificationCountGraph,
        KarinDenunciationCountGraph,
        DashboardUnfiltered,
    },

    async created() {
        //signal R invoke - back to front
        const start = dateFormat(-1);
        const end = dateFormat(); 
        await countKarinDenunciationsSignalRInvoke(start, end);

        await allDocumentsSignalRInvoke(start, end);

        await countDenunciationsSignalRInvoke(start, end);
        await countDocumentsSignalRInvoke(start, end);

        await countMeetsSignalRInvoke(start, end);

        await countSendDocumentsSignalRInvoke(start, end);
        await countSendDenunciationSignalRInvoke(start, end);

        await countStatementsSignalRInvoke(start, end);
        await countSendStatementsSignalRInvoke(start, end);
    }

}
</script>
<style></style>
